__turbopack_context__.v({
  "className": "noto_sans_kannada_50c6f72-module___Sj-Xq__className",
});
